import { UserRole } from "../services/auth/auth.types"
import React, { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuthContext } from "../services/auth/hooks/useAuthContext"
import { Loading } from "./Loading"

interface ProtectedProps {
  children?: ReactNode
  roles?: UserRole[]
}

export const Protected: React.FC<ProtectedProps> = ({ children, roles }) => {
  const { isAuth, role, loading } = useAuthContext()
  const location = useLocation()
  const hasAccess = (isAuth: boolean, role: UserRole | null) => {
    if (!roles || !roles.length) {
      return isAuth
    } else if (role) {
      return roles.includes(role)
    }
    return false
  }
  if (loading) return <Loading />
  if (!hasAccess(isAuth(), role)) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  return <>{children}</>
}
